/**
 * @fileoverview View mode content for production order target details modal
 */
import React from "react";
import PropTypes from "prop-types";
import { intl } from "dmsbasereact";
import { Box, Grid } from "@mui/material";
import InventoryIcon from "@mui/icons-material/Inventory";
import AssignmentIcon from "@mui/icons-material/Assignment";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { DmsInfoCard } from "../../DmsDetailModal/DmsInfoCard";
import { DmsInfoField } from "../../DmsDetailModal/DmsInfoField";

/**
 * Format datetime for display
 */
const formatDateTime = (dateStr) => {
  if (!dateStr) return "-";
  const date = new Date(dateStr);
  return date.toLocaleString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

/**
 * View mode content for displaying production order target details
 */
export const ViewModeContent = ({ data }) => {
  const target = data;
  
  if (!target) {
    return null;
  }

  return (
    <Box sx={{ maxHeight: "70vh", overflowY: "auto" }}>
      {/* Target Information */}
      <DmsInfoCard icon={<InventoryIcon />} title={intl.get("TargetInfo").d("Output Information")}>
        <Grid container spacing={2}>
          <DmsInfoField 
            label={intl.get("PK").d("Internal ID (PK)")} 
            value={target.pk} 
            xs={6}
            sm={3}
          />
          <DmsInfoField 
            label={intl.get("Quantity").d("Quantity")} 
            value={target.quantity ? target.quantity.toLocaleString("pt-BR") : "0"} 
            xs={6}
            sm={3}
          />
        </Grid>
      </DmsInfoCard>

      {/* Related Entities */}
      <DmsInfoCard icon={<AssignmentIcon />} title={intl.get("RelatedEntities").d("Related Entities")}>
        <Grid container spacing={2}>
          <DmsInfoField 
            label={intl.get("ProductionOrderPk").d("Production Order ID (PK)")} 
            value={target.production_order_pk} 
            xs={12}
            sm={6}
          />
          <DmsInfoField 
            label={intl.get("BatchPk").d("Batch ID (PK)")} 
            value={target.batch_pk} 
            xs={12}
            sm={6}
          />
        </Grid>
      </DmsInfoCard>

      {/* Timestamps */}
      <DmsInfoCard icon={<AccessTimeIcon />} title={intl.get("Timestamps").d("Dates")}>
        <Grid container spacing={2}>
          <DmsInfoField 
            label={intl.get("CreatedOn").d("Created On")} 
            value={formatDateTime(target.created_on)} 
            xs={12}
            sm={6}
          />
          <DmsInfoField 
            label={intl.get("UpdatedOn").d("Updated On")} 
            value={formatDateTime(target.updated_on)} 
            xs={12}
            sm={6}
          />
        </Grid>
      </DmsInfoCard>
    </Box>
  );
};

ViewModeContent.propTypes = {
  data: PropTypes.object.isRequired,
};

